"use strict";
/**
 * Re-exports commonly used modules:
 * * Adds [`ethjs-util`](https://github.com/ethjs/ethjs-util) methods.
 * * Exports [`BN`](https://github.com/indutny/bn.js), [`rlp`](https://github.com/ethereumjs/rlp).
 * @packageDocumentation
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ethjsUtil = require('ethjs-util');
var BN = require("bn.js");
exports.BN = BN;
var rlp = require("rlp");
exports.rlp = rlp;
/**
 * [`ethjsUtil`](https://github.com/ethjs/ethjs-util)
 */
Object.assign(exports, ethjsUtil);
//# sourceMappingURL=externals.js.map